import { useState } from "react";

export const useCaseMergeActions = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSeparate = async (selectedCases) => {
    setIsLoading(true);
    setError(null);

    try {
      const caseIdsWithPersonId = selectedCases.map((record) => ({
        id: record.id,
        PERSON_ID: record.PERSON_ID,
      }));

      const res = await fetch("/api/separateCase", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ CASES: caseIdsWithPersonId }),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Server responded with ${res.status}: ${text}`);
      }

      return { success: true };
    } catch (err) {
      setError(err.message || "Failed to separate cases.");
      return { success: false, error: err.message };
    } finally {
      setIsLoading(false);
    }
  };

  const handleAutoMerge = async (primaryCase, secondaryCases) => {
    setIsLoading(true);
    setError(null);

    try {
      const dataToPass = {
        CASE: primaryCase,
        MERGES: secondaryCases,
      };

      const res = await fetch("/api/mergeCases", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataToPass),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Server responded with ${res.status}: ${text}`);
      }

      return { success: true };
    } catch (err) {
      setError(err.message || "Auto merge failed.");
      return { success: false, error: err.message };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleSeparate,
    handleAutoMerge,
    isLoading,
    error,
  };
};
